import { SelfDescribingJson } from '@snowplow/tracker-core';

import { CollaborationContext } from '../contexts/CollaborationContext';

export const mapCollaborationContext = (
  collaboration: CollaborationContext,
): SelfDescribingJson<Record<string, unknown>> => {
  const { existingMembers, newMembers, guestToPromote, groups, nCollaborators } =
    collaboration;

  return {
    schema: 'iglu:com.genially/collaboration/jsonschema/1-0-0',
    data: {
      existing_members: {
        amount: existingMembers.amount,
        n_readonly: existingMembers.nReadonly,
      },
      new_members: {
        amount: newMembers.amount,
        n_readonly: newMembers.nReadonly,
        collaborator_role: newMembers.collaboratorRole,
      },
      guest_to_promote: {
        amount: guestToPromote.amount,
        n_readonly: guestToPromote.nReadonly,
      },
      groups: { amount: groups.amount, n_readonly: groups.nReadonly },
      n_collaborators: nCollaborators,
    },
  };
};
